module.exports = {"":{"domain":"sentry","plural_forms":"nplurals=2; plural=(n != 1)","lang":"en"}};


//////////////////
// WEBPACK FOOTER
// /usr/src/sentry/src/sentry/locale/en/LC_MESSAGES/django.po
// module id = 852
// module chunks = 74